__turbopack_context__.v({
  "className": "manrope_b89899fa-module__Clj5fG__className",
});
